// extracted by mini-css-extract-plugin
export default {"Background":"LoadingProgress_Background__-M6VQ","Wrapper":"LoadingProgress_Wrapper__OHsvG","LoadingProgress":"LoadingProgress_LoadingProgress__n92Nq"};